import type { Variants, Transition } from 'framer-motion';
import { DURATION, EASING, prefersReducedMotion } from './animations';

// Route transition variants
export const routeTransitions: Variants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

// Route transition timing
export const routeTransition: Transition = {
  duration: DURATION.normal,
  ease: EASING.easeInOut,
};

// Shared element transition helper
export function sharedElementId(type: string, id: string): string {
  return `${type}-${id}`;
}

// Get route variants respecting reduced motion
export function getRouteVariants(): Variants {
  if (prefersReducedMotion()) {
    return {
      initial: {},
      animate: {},
      exit: {},
    };
  }
  return routeTransitions;
}

// Get route transition respecting reduced motion
export function getRouteTransition(): Transition {
  if (prefersReducedMotion()) {
    return { duration: 0 };
  }
  return routeTransition;
}
